import React, { useState } from 'react'
import styles from './index.module.css'

import {
  Grid,
  Typography,
  makeStyles,
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText,
} from '@material-ui/core'
import Input from '../../input'
import CustomSelect from '../../custom-select'
import { Controller } from 'react-hook-form'
import { provinceList, municipalities, capOptionsFor } from '../address-data'
import AddressAutocomplete from '../address-autocomplete'
import _ from 'lodash'
import {
  KeyboardDatePicker, MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'

export default ({ register, control, errors, watch, setValue, onDocumentChange, isReadingDocument, documentError}) => {
  const residence = watch("residenceMunicipality", "");
  const [selectedResidence, setSelectedResidence] = useState(null);
  const update = (name, value) => setValue(name, value, { shouldValidate: true, shouldDirty: true });
  const listaSessi = [
    {
      value: 'M',
      label: 'Uomo'
    },
    {
      value: 'F',
      label: 'Donna'
    },
    {
      value: 'O',
      label: 'Non specificato'
    }
  ]
  const listaProvince = provinceList.map(provincia => ({
    value: provincia.sigla,
    label: `${provincia.nome} (${provincia.sigla})`
  })).sort((a,b) => (a.label > b.label) ? 1 : (a.label < b.label) ? -1 : 0)

  const listaRegioni = _.uniq(provinceList.map(provincia => provincia.regione)).map(regione => ({
    value: regione,
    label: regione
  })).sort((a,b) => (a.label > b.label) ? 1 : (a.label < b.label) ? -1 : 0)

  const useStyles = makeStyles(() => ({
    datePickerRoot: {
      height: 50,
      boxShadow: '0px 3px 6px #00000029',
      fontSize: "1rem",
      fontWeight: 700,
      padding: '0 20px',
      display: 'flex',
      justifyContent: 'center'
    },
    label: {
      fontSize: "1rem",
      fontFamily: '"Times New Roman", Times, serif',
      fontWeight: 'bold',
      marginBottom: 2,
    },
  }))

  const classes = useStyles()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5" className={styles.sectionTitle}>Dati anagrafici</Typography>
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="name"
          inputRef={register}
          placeholder="Inserisci il tuo nome"
          fullWidth
          label="Nome"
          helperText={errors?.name?.message}
          error={!!errors?.name?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="surname"
          inputRef={register}
          placeholder="Inserisci il tuo cognome"
          fullWidth
          label="Cognome"
          helperText={errors?.surname?.message}
          error={!!errors?.surname?.message}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography
          component="label"
          htmlFor="birthDate"
          className={classes.label}
        >
          {'Data di Nascita'}
        </Typography>
        <MuiPickersUtilsProvider utils={MomentUtils}>
        <Controller
          render={({ value, onChange, onBlur }) => (
              <KeyboardDatePicker
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                id="birthDate"
                format="DD/MM/YYYY"
                helperText={errors?.birthDate?.message}
                error={!!errors?.birthDate}
                emptyLabel={'__/__/____'}
                mask={'__/__/____'}
                variant={'outlined'}
                classes={{
                  root: classes.datePickerRoot,
                }}
                InputProps={{
                  disableUnderline: true,
                }}
              />
          )}
          name="birthDate"
          control={control}
        />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          render={({ value, onChange, onBlur }) => (
            <CustomSelect
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              themed
              className={styles.input}
              label="Sesso *"
              helperText={errors?.gender?.message}
              error={!!errors?.gender}
              placeholder="Seleziona il sesso"
              items={listaSessi}
            />
          )}
          name="gender"
          control={control}
          defaultValue=""
        />
      </Grid>
      <Grid item xs={12}>
        <Controller name="birthCity" control={control} defaultValue=""
          render={({ value, onChange, onBlur }) => <AddressAutocomplete
            id="birthCity" name="birthCity" label="Città di nascita" value={value} onChange={onChange} onBlur={onBlur}
            options={municipalities} placeholder="Scrivi almeno 2 lettere, per esempio reg…"
            helperText={errors?.birthCity?.message} error={!!errors?.birthCity}
            onSelect={city => { update('birthRegion', city.regione); update('birthProvince', city.sigla); }}
          />}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          render={({ value, onChange, onBlur }) => (
            <CustomSelect
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              themed
              className={styles.input}
              label="Regione di nascita *"
              helperText={errors?.birthRegion?.message}
              error={!!errors?.birthRegion}
              placeholder="Inserisci la tua regione di nascita"
              items={listaRegioni}
            />
          )}
          name="birthRegion"
          control={control}
          defaultValue=""
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          render={({ value, onChange, onBlur }) => (
            <CustomSelect
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              themed
              className={styles.input}
              label="Provincia di nascita *"
              helperText={errors?.birthProvince?.message}
              error={!!errors?.birthProvince}
              placeholder="Inserisci la tua provincia di nascita"
              items={listaProvince}
            />
          )}
          name="birthProvince"
          control={control}
          defaultValue=""
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Controller name="residenceMunicipality" control={control} defaultValue=""
          render={({ value, onChange, onBlur }) => <AddressAutocomplete
            id="residenceMunicipality" name="residenceMunicipality" label="Comune di residenza" value={value} onChange={onChange} onBlur={onBlur}
            options={municipalities} placeholder="Inizia a scrivere il comune"
            helperText={errors?.residenceMunicipality?.message} error={!!errors?.residenceMunicipality}
            onSelect={city => {
              setSelectedResidence(city);
              const currentCAP = watch('CAP', '');
              if (city.cap.length === 1) update('CAP', city.cap[0]);
              else if (currentCAP && !city.cap.includes(currentCAP)) update('CAP', '');
            }}
          />}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Controller name="CAP" control={control} defaultValue=""
          render={({ value, onChange, onBlur }) => <AddressAutocomplete
            id="CAP" name="CAP" label="CAP" value={value} onChange={onChange} onBlur={onBlur}
            options={capOptionsFor(residence, selectedResidence)} numeric placeholder="Scrivi o scegli il CAP"
            helperText={errors?.CAP?.message} error={!!errors?.CAP}
            onSelect={option => { if (!residence.trim() && option.cities.length === 1) update('residenceMunicipality', option.cities[0].nome); }}
          />}
        />
        <Typography className={styles.capHelp}>Per i comuni con più CAP, scegli quello del tuo indirizzo. Puoi sempre digitarlo manualmente.</Typography>
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="profession"
          inputRef={register}
          placeholder="Inserisci la tua professione"
          fullWidth
          label="Professione"
          helperText={errors?.profession?.message}
          error={!!errors?.profession?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset" error={!!errors?.activeCollaboration} className={styles.collaboration}>
          <FormLabel component="legend" className={classes.label}>Intendi collaborare attivamente nel MRF?</FormLabel>
          <Controller
            name="activeCollaboration"
            control={control}
            defaultValue=""
            render={({ value, onChange, onBlur }) => (
              <RadioGroup
                row
                aria-label="Intendi collaborare attivamente nel MRF?"
                name="activeCollaboration"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
              >
                <FormControlLabel value="yes" control={<Radio color="primary" />} label="Sì" />
                <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
              </RadioGroup>
            )}
          />
          {errors?.activeCollaboration && <FormHelperText>{errors.activeCollaboration.message}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Input
          className={styles.input}
          name="document"
          placeholder="Seleziona un documento d'identità, la patente, o il passaporto"
          fullWidth
          label="Documento di riconoscimento (carta d'identità, patente, o passaporto)"
          type="file"
          onChange={onDocumentChange}
          helperText={documentError || 'Il documento è richiesto per verificare l’identità del richiedente.'}
          error={!!documentError}
        />
      </Grid>
      <Grid item xs={12}>
        {isReadingDocument && <Typography role="status" className={styles.instructions}>Caricamento documento…</Typography>}
      </Grid>
    </Grid>
  )
}
